<template lang="pug">
.login
	.twoFA(v-if="twoFactorPrompt")
		two-factor-auth(v-if="this.twoFactorRegistered", :user="this.User", @submitted="handleTwoFactor", :loading="loading")
		register-two-factor-auth(v-else, :user="this.User", @submitted="handleTwoFactor", :loading="loading")
	el-form(v-else, :model="form", :rules="rules", @submit.native.prevent="handleFormSubmit")
		el-form-item(label='Email', prop="username")
			el-input(type="email", v-model="form.username")
		el-form-item(label='Password', prop="password").login__password
			el-input(type="password", v-model="form.password")
		el-button(type="primary", native-type="submit", :loading="loading") Login
		//- router-link(:to="{name: 'auth.send-password-reset', query: { email: form.email }}")
		//- 	el-button.reset-password(type="text").login__forgot Forgot Password
</template>

<script>
import gql from "graphql-tag";
import { onLogin } from "@/vue-apollo";
import TwoFactorAuth from "@/views/auth/TwoFactorAuth";
import RegisterTwoFactorAuth from "@/views/auth/RegisterTwoFactorAuth";

export default {
	name: "Login",
	components: { TwoFactorAuth, RegisterTwoFactorAuth },
	data: () => ({
		User: null,
		loading: false,
		twoFactorPrompt: false,
		twoFactorCode: undefined,
		form: {
			username: undefined,
			password: undefined
		},
		rules: {
			email: [{ required: true, trigger: "blur", message: "Valid email is required", type: "email" }],
			password: [{ required: true, trigger: "blur", message: "Password is required" }]
		},
	}),
	methods: {
		async handleFormSubmit() {
			this.loading = true;

			try {
				await this.findUser();

				if (this.User.enable_2fa) {
					this.twoFactorPrompt = true;
				} else {
					let companies = this.User.companies;
					if (companies.filter(i => i.two_factor_auth).length) {
						this.twoFactorPrompt = true;
					} else {
						await this.attemptLogin();
					}
				}
			} catch (error) {
				this.$message.error("Login failed. Please try again");
			}

			this.loading = false;
		},
		async handleTwoFactor(twoFactorCode) {
			this.twoFactorCode = twoFactorCode;

			await this.attemptLogin();
		},
		async attemptLogin() {
			this.loading = true;
			
			try {
				const result = await this.$apollo.mutate({
					client: "public",
					mutation: gql`
						mutation Login($username: String!, $password: String!, $twoFactorCode: String) {
							Login(username: $username, password: $password, twoFactorCode: $twoFactorCode)
						}
					`,
					variables: { ...this.form, twoFactorCode: this.twoFactorCode }
				});

				await onLogin(result.data.Login);
				
				if (this.User.with_password_history) {
					this.$router.push({
						name: "schools"
					});
				} else {
					this.$router.push({
						name: "auth.change-password",
						params: { token:  result.data.Login }
					});
				}		
				
			} catch (error) {
				if (error.message) {
					if (error.message.includes("Rate Error")) {
						return this.$message.error("Account locked. Please try again in a few minutes");
					}
					if (error.message.includes("Invalid Verification")) {
						this.loading = false;
						return this.$message.error("Invalid Two Factor Verification, please try again");
					}
				}

				this.$message.error("Login failed. Please try again");
			}			

			this.loading = false;
		},
		async findUser() {
			await this.$apollo
				.query({
					client: "public",
					query: gql`
						query User($username: String!, $password: String!) {
							User(username: $username, password: $password) {
								id,
								enable_2fa,
								secret_2fa_exists,
								companies {
									id,
									name,
									two_factor_auth
								},
								with_password_history
							}
						}
					`,
					variables: { ...this.form }
				})
				.then(response => (this.User = response.data.User));
		}
	},
	computed: {
		twoFactorRegistered() {
			return this.User ? !!this.User.secret_2fa_exists : false;
		}
	}
};
</script>
